import * as types from './personal-note.types';
import * as constants from './personal-note.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storePersonalNote = generateStoreResourceAction<types.IPersonalNote>(constants.STORE_PERSONAL_NOTE);
export const clearPersonalNote = generateClearResourceAction(constants.CLEAR_PERSONAL_NOTE);
